import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('username', email);
      formData.append('password', password);

      const response = await axios.post(`${BACKEND_URL}/api/admin/login`, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      localStorage.setItem('admin_token', response.data.access_token);
      toast.success('Connexion réussie !');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error('Email ou mot de passe incorrect');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a365d] to-[#2a4a6d] flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 bg-white shadow-2xl">
        <div className="text-center mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_netanya-elite-homes/artifacts/wuykmx8d_image0.png"
            alt="BuyIt.il Logo"
            className="h-20 mx-auto mb-4"
          />
          <h1 className="text-2xl font-bold text-[#1a365d]">Panel Administrateur</h1>
          <p className="text-gray-600 mt-2">BuyIt.il - Luxury Real Estate</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="buyit.office@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password">Mot de passe</Label>
            <Input
              id="password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <Button
            type="submit"
            className="w-full bg-[#1a365d] hover:bg-[#d4af37] text-white py-6 text-lg font-semibold"
            disabled={loading}
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </Button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-500">
          <p>Email par défaut: buyit.office@gmail.com</p>
          <p>Mot de passe: BuyIt2025!Admin</p>
          <p className="text-xs mt-2 text-red-600">⚠️ Changez le mot de passe après la première connexion</p>
        </div>
      </Card>
    </div>
  );
};

export default AdminLogin;
